module.exports = __webpack_public_path__ + "static/media/heart.c6efa398.jpg";